import React from 'react'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Icon from '@material-ui/core/Icon'
import Divider from '@material-ui/core/Divider'

import { DeviceContext } from '../contexts/deviceContext'
import { CameraContext } from '../contexts/cameraContext'

import '../styles/main-header.scss'
import playIcon from '../images/play-icon.png'
import logoImage from '../images/landing-page/logo3.svg'
import { ReactComponent as EventbookIcon } from '../images/eventbook-icon.svg'
import CryptoJS from 'crypto-js'
import * as tfvis from '@tensorflow/tfjs-vis'

export default function MainHeader(props) {
    const deviceContext = React.useContext(DeviceContext)
    const cameraContext = React.useContext(CameraContext)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [eventBookData, setEventBookData] = React.useState(null)
    const iframeRef = React.useRef(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const { owner, email, jid } = deviceContext

    function onIframeLoad() {
        if (iframeRef.current) {
            const css =
                'button[name="event-item-back-button"], button[name="eventbook-back-button"] {display: none !important;} header[name="main-header"] {display: none !important;} #root > div, .loading-section, .loading-section_show {padding-top: 0px !important; top: 0px !important; height: 100% !important;}'
            const window = iframeRef.current.contentWindow
            const document = window.contentDocument || window.document
            const head = document.head
            const style = document.createElement('style')
            head.appendChild(style)
            style.type = 'text/css'
            if (style.styleSheet) {
                // This is required for IE8 and below.
                style.styleSheet.cssText = css
            } else {
                style.appendChild(document.createTextNode(css))
            }
            window.onpopstate = closeEventBook
            setEventBookData({
                ...eventBookData,
                finish: true,
            })
        }
    }

    function onClickBackButton() {
        if (iframeRef.current) {
            const window = iframeRef.current.contentWindow
            const document = window.contentDocument || window.document
            const eventItemBackButton = document.querySelector(
                'button[name="event-item-back-button"]'
            )
            if (eventItemBackButton) {
                eventItemBackButton.click()
            } else {
                closeEventBook()
            }
        }
    }

    function closeEventBook() {
        setEventBookData(null)
    }

    function rendeHeader() {
        const { eventPreferences, isPremium } = deviceContext
        return (
            <div className="main-header">
                <img
                    width={324}
                    height={40}
                    src={logoImage}
                    onClick={() => {
                        closeEventBook()
                        window.eventManager.sendEngagementBehavior('logo')
                    }}
                />
                <div
                    className={classnames('nav-item', {
                        active: !eventBookData,
                    })}
                    onClick={() => {
                        closeEventBook()
                        window.eventManager.sendEngagementBehavior('camera')
                    }}
                >
                    <Icon className="nav-item__icon">videocam</Icon>
                    <span className="nav-item__text">
                        <FormattedMessage id="local_camera" />
                    </span>
                </div>
                {isPremium && (
                    <div
                        className={classnames('nav-item eventbook-button', {
                            active: eventBookData,
                        })}
                        onClick={(e) => {
                            if (eventBookData) {
                                if (iframeRef.current) {
                                    const window =
                                        iframeRef.current.contentWindow
                                    setEventBookData({
                                        ...eventBookData,
                                        finish: false,
                                    })
                                    window.location.reload()
                                } else {
                                    closeEventBook()
                                }
                            } else {
                                setEventBookData({
                                    url: `device/${CryptoJS.MD5(
                                        jid
                                    ).toString()}/eventbooks`,
                                    finish: false,
                                })
                            }
                            // unhandle promise
                            deviceContext.mutations.onLoadEventbookSuccess()
                            window.eventManager.sendEngagementBehavior(
                                'eventbook'
                            )
                        }}
                    >
                        <EventbookIcon className="nav-item__icon eventbook-icon" />
                        <span className="nav-item__text">
                            <FormattedMessage id="eventbook" />
                        </span>
                        {eventPreferences &&
                            ((eventPreferences.lastEventCreatedAt &&
                                !eventPreferences.lastEventbookSeenAt) ||
                                eventPreferences.lastEventCreatedAt >
                                    eventPreferences.lastEventbookSeenAt) && (
                                <span className="red-point" />
                            )}
                    </div>
                )}
                <div
                    className="nav-item"
                    onClick={(e) => {
                        window.open('https://alfredcamera.zendesk.com/hc')
                        window.eventManager.sendEngagementBehavior('faq')
                    }}
                >
                    <Icon className="nav-item__icon">help</Icon>
                    <span className="nav-item__text">
                        <FormattedMessage id="FAQ" />
                    </span>
                </div>
                {window.alfredTest2wsxsw2 ? (
                    <div className="nav-item" onClick={props.openTestPanel}>
                        <span className="nav-item__text">DEBUG</span>
                    </div>
                ) : (
                    ''
                )}
                {window.alfredTest2wsxsw2 ? (
                    <div
                        className="nav-item"
                        onClick={() => {
                            tfvis.visor().open()
                        }}
                    >
                        <span className="nav-item__text">PROFILER</span>
                    </div>
                ) : (
                    ''
                )}
                <a
                    className="to-webviewer"
                    target="_blank"
                    href="/webapp/viewer?utm_source=webcamera&utm_medium=referral&utm_campaign=header_right"
                    onClick={() =>
                        window.eventManager.sendEngagementBehavior('webviewer')
                    }
                >
                    <img className="play-icon" src={playIcon} width="8px"></img>
                    <span>WebViewer</span>
                </a>
                <div
                    className="avatar"
                    onClick={(e) => {
                        handleClick(e)
                        window.eventManager.sendEngagementBehavior('account')
                    }}
                >
                    <img
                        className="avatar__image"
                        src={owner.picture}
                        alt="avatar"
                        width="40"
                        height="40"
                    />
                </div>
                <Menu
                    id="accountMenu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => handleClick(false)}
                >
                    <ListItem
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            return false
                        }}
                    >
                        <div className="user-info">
                            <div className="avatar">
                                <img
                                    className="avatar__image"
                                    src={owner.picture}
                                    alt="avatar"
                                    width="40"
                                    height="40"
                                />
                            </div>
                            <div className="user-detail">
                                <p className="user-name">{owner.name}</p>
                                <p className="user-email">{email}</p>
                            </div>
                        </div>
                    </ListItem>
                    <Divider />
                    <MenuItem
                        onClick={(e) =>
                            window.open(
                                'https://alfred.camera/legal/terms-of-service'
                            )
                        }
                    >
                        <ListItemIcon>
                            <Icon>description</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="TermsofService" />
                        </span>
                    </MenuItem>
                    <MenuItem
                        onClick={(e) =>
                            window.open(
                                'https://alfred.camera/legal/privacy-policy'
                            )
                        }
                    >
                        <ListItemIcon>
                            <Icon>description</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="PrivatePolicy" />
                        </span>
                    </MenuItem>
                    <MenuItem
                        onClick={(e) =>
                            window.open(
                                'https://alfred.camera/userfeedback/tech_web'
                            )
                        }
                    >
                        <ListItemIcon>
                            <Icon>email</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="contactUs" />
                        </span>
                    </MenuItem>
                    <Divider />
                    <MenuItem
                        onClick={() => {
                            deviceContext.mutations.signOut()
                            cameraContext.mutations.resetState()
                        }}
                    >
                        <ListItemIcon>
                            <Icon>exit_to_app</Icon>
                        </ListItemIcon>
                        <span>
                            <FormattedMessage id="signOut" />
                        </span>
                    </MenuItem>
                </Menu>
            </div>
        )
    }

    return (
        <>
            {rendeHeader()}
            {eventBookData && (
                <>
                    <div
                        className="eventbook-close"
                        onClick={onClickBackButton}
                    >
                        <Icon>arrow_back</Icon>
                    </div>
                    <iframe
                        src={`/webapp/viewer/${eventBookData.url}?utm_source=webcamera&utm_medium=referral&utm_campaign=header_eventbook`}
                        className={classnames('eventbook', {
                            finish: eventBookData.finish,
                        })}
                        ref={iframeRef}
                        onLoad={onIframeLoad}
                    />
                </>
            )}
        </>
    )
}
